'use client';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

type Props = {
  selected?: string;
  onChange?: (newSelected: string) => void;
  isMobile?: boolean;
};

export const SortSwitch: React.FC<Props> = ({ selected, onChange, isMobile: _isMobile = false }) => {
  const t = useTranslations('filtersScreen');

  const handleChange = (newVal: string) => {
    onChange?.(newVal);
  };

  const data = [
    { label: t('sortByNewest'), value: 'createdAt|desc' },
    { label: t('sortByCheapest'), value: 'price|asc' },
    { label: t('sortByExpensive'), value: 'price|desc' },
  ];

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <div className='flex gap-[4px] cursor-pointer'>
          <Image alt='' src='/assets/icons/sort-direction.svg' height={20} width={20} />
          <span className='text-[13px] text-primary font-normal md:inline-block hidden'>
            {<> {selected === '' ? t('sort') : data.find(({ value }) => value === selected)?.label}</>}
          </span>
        </div>
      </DropdownMenuTrigger>

      <DropdownMenuContent side='bottom' align='end' sideOffset={8} className='max-h-[300px] overflow-auto'>
        <DropdownMenuRadioGroup value={selected} onValueChange={handleChange}>
          {data.map((item) => (
            <DropdownMenuRadioItem key={item.value} value={item.value}>
              {item.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
